// ============================================================
// ConfirmationScreen.tsx
// Forgot Password — step 2 (post-request). Static "check your email"
// screen rendered after RequestResetScreen's onSuccess fires. No
// state, no API calls — copy is deliberately vague about whether the
// email matched a real account (account-enumeration prevention).
// ============================================================
import React from 'react'
interface ConfirmationScreenProps {
  onShowLogin: () => void
}
const ConfirmationScreen: React.FC<ConfirmationScreenProps> = ({ onShowLogin }) => {
  return (
    <div className="min-h-screen bg-casevo-offwhite font-sans flex flex-col">
      {/* Nav bar — same recipe as LoginScreen / RequestResetScreen. */}
      <nav className="bg-casevo-header px-4 sm:px-6 h-14 flex items-center border-b border-casevo-border">
        <div className="flex items-center gap-3">
          <svg width="28" height="28" viewBox="0 0 68 68">
            <circle cx="34" cy="34" r="34" fill="#2d6a4f"/>
            <rect x="23" y="17" width="9" height="34" rx="4.5" fill="#ffffff"/>
            <rect x="36" y="22" width="9" height="24" rx="4.5" fill="#74c69d"/>
          </svg>
          <div className="flex flex-col">
            <span className="text-white font-medium text-sm tracking-widest uppercase leading-none">Casevo</span>
            <span className="text-casevo-light text-xs tracking-widest uppercase leading-none">Case Management</span>
          </div>
        </div>
      </nav>
      {/* Confirmation message */}
      <div className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-sm">
          <div className="mb-6">
            <p className="text-xs uppercase tracking-widest text-casevo-brand mb-2">Check your email</p>
            <h1 className="text-2xl font-medium text-casevo-forest">Reset link sent</h1>
          </div>
          <p className="text-sm text-casevo-mid mb-6">
            If an account exists for that email, you'll receive a reset link shortly. Please check your inbox and spam folder.
          </p>
          <p className="text-center text-sm text-casevo-mid mt-6">
            <button onClick={onShowLogin} className="text-casevo-brand underline">
              Back to login
            </button>
          </p>
        </div>
      </div>
    </div>
  )
}
export default ConfirmationScreen
